import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const ADMINURL = process.env.REACT_APP_API_URL;

const BASE_URL = ADMINURL;

  export const refreshAccessToken = async () => {

    const handleLogout = () => {
      localStorage.clear();
      window.location.reload();
  };

    try {
      const refreshToken = localStorage.getItem("refreshToken");
      if (!refreshToken) throw new Error("No refresh token");

      const response = await axios.post(
        `${BASE_URL}/admin/get-access-token`,
        {},
        {
          headers: {
            Authorization: `Bearer ${refreshToken}`,
          },
        }
      );

      if (response?.data?.sts == 0) {
        const newToken = response.data?.data.accessToken;
        const newRefreshToken = response.data?.data.refreshToken;

        localStorage.setItem("token", newToken);
        localStorage.setItem("refreshToken", newRefreshToken);

        return newToken;
      }

      throw new Error("Refresh token failed");
    } catch (err) {
      handleLogout();
      return null;
    }
  };

const useApi = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();
    navigate("/"); // redirect to login
    window.location.reload();
  };

  const trigger = async ({
    endpoint = "",
    method = "post",
    payload = {},
    config = {},
    requireAuth = false,
    contentType = "application/json",
     responseType = "json",
  }) => {
    setLoading(true);
    setError(null);
    setData(null);

    const makeRequest = async (token) => {
      let headers = {
        ...(config.headers || {}),
        ...(requireAuth && token ? { Authorization: `Bearer ${token}` } : {}),
      };

      if (!(payload instanceof FormData)) {
        headers["Content-Type"] = contentType;
      }

      const finalConfig = { ...config, headers,responseType };
      const fullUrl = `${BASE_URL}${endpoint.startsWith("/") ? "" : "/"}${endpoint}`;

      return axios({ url: fullUrl, method, data: payload, ...finalConfig });
    };

    try {
      let token = requireAuth ? localStorage.getItem("token") : null;
      let response;

      try {
        // First attempt
        response = await makeRequest(token);
      } catch (err) {

        if (requireAuth && (err.response?.status == 401 || err?.response?.data?.sts == 2)) {
          console.log("Token expired → refreshing...");
          token = await refreshAccessToken();
          if (!token) throw err;

          // Retry once with new token
          response = await makeRequest(token);
        } else {
          throw err; // other errors
        }
      }
          //  Return raw blob or arraybuffer data directly
          if (responseType === "blob" || responseType === "arraybuffer") {
            // return response.data;
            return response;
          }

      // Success response
      setData(response.data);
      if(contentType === "application/pdf"){
        return response;
      }
      return response.data;
    } catch (err) {
      if (err.response?.status == 401 && requireAuth) {
        handleLogout();
      }
      setError(err);
      return err.response?.data ?? null;
    } finally {
      setLoading(false);
    }
  };

  return { trigger, loading, error, data };
};

export default useApi;

// const { trigger, data, error, loading } = useApi();

//   trigger({
//     endpoint: "/upload",
//     method: "post",
//     payload: formData,
//     contentType: "multipart/form-data",
//     requireAuth: true,
//   });